"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedclocksm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedclocksm` : '') + (description ? ` desc-brandedclocksm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedclocksm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedclocksm"
  }, description), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_13994_4588",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "9.99844",
    cy: "10.0063",
    r: "9.6",
    fill: "#D9D9D9"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_13994_4588)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "9.99844",
    cy: "10.0063",
    r: "9.6",
    fill: "#F26B1C"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.72 2.27a.28.28 0 0 1 .56 0l.47 8.54a.76.76 0 1 1-1.5 0l.47-8.54Z",
    fill: "#DAFCFE"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.28 14.06a.29.29 0 0 1-.36.46L9.59 11.7a.73.73 0 1 1 .9-1.16l3.79 3.51Z",
    fill: "#8AE6EB"
  }));
};
var _default = exports.default = brandedclocksm;